<mat-dialog-content>
	<div data-test-id="dialog-message" tabindex="0" [innerHTML]="data.message"></div>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-flat-button dialogFocus color="primary" [mat-dialog-close]="data" (click)="data.acknowledged = true"
	        class="focus-inwards-dark" data-test-id="dialog-true-button">{{ data.buttonLabel }}
	</button>
</mat-dialog-actions>
